module.exports = __webpack_public_path__ + "img/bottle-pink.11dfd423.svg";